// Encapsulate code in Immediately Invoked Functional Expression
var Carousel = (function() {

  // Invoke strict mode
  "use strict";

  /**
   * Class to handle carousel related functionality.
   *
   * @class Carousel
   */
  var Carousel = function(parent, key) {

    // Cache the key/prefix provided or fallback
    key = key || "carousel";
    this.key = key;

    // Placeholder for the carousel index
    this.index = 0;

    // Placeholder for the carousel elements
    this.ui = {};

    // Get the DOM element references
    this.ui.wrapper = dom("." + key + "-wrapper", parent);
    this.ui.mask = dom("." + key + "-mask", parent);
    this.ui.tabs = utils.convertNodeListToArray(
      doms("." + key + "-pagination-tab-item", parent)
    );
    this.ui.pagination = utils.convertNodeListToArray(
      doms("." + key + "-pagination-item", parent)
    );
    this.ui.items = utils.convertNodeListToArray(
      doms("." + key + "-item", parent)
    );
    this.ui.buttons = utils.convertNodeListToArray(
      doms("." + key + "-button", parent)
    );
    this.ui.links = utils.convertNodeListToArray(
      doms(".link-cta", parent)
    );

    // Set the overflow to mask the carousel
    this.ui.mask.style.overflow = "hidden";

    // Iterate over the pagination elements
    this.ui.tabs.forEach(function(tab, index) {
      // Handle on click of pagination item
      dom("button", tab).onclick = this.paginate.bind(this);
    }, this);

    // Iterate over the button elements
    this.ui.buttons.forEach(function(button, index) {
      // Handle on click of button
      button.onclick = this.click.bind(this);
    }, this);

    // Bind the handler to the key down event on the document
    document.addEventListener("keydown", this.keydown.bind(this));

    // Trigger the initial layout
    this.scroll();

  };

  /**
   * Method to get the next/previous index, including wrapping the start/end.
   *
   * @method Carousel.getNextIndex
   */
  Carousel.prototype.getNextIndex = function(next) {

    var count = this.ui.tabs.length;
    var index = this.index + (next ? 1 : -1);

    // Keep within bounds of list
    if (next) {
      if (index >= count) {
        index = 0;
      }
    } else {
      if (index < 0) {
        index = count - 1;
      }
    }

    return index;

  };

  /**
   * Method to handle clicking on the directional buttons.
   *
   * @method Carousel.click
   */
  Carousel.prototype.click = function(event) {

    // Prevent default click functionality
    event.preventDefault();

    // Get flag for if moving forward
    var next = event.target.getAttribute("data-direction") === "next";

    // Update active index
    this.index = this.getNextIndex(next);

    // Scroll the carousel
    this.scroll();

  };

  /**
   * Method to handle clicking on the pagination buttons.
   *
   * @method Carousel.paginate
   */
  Carousel.prototype.paginate = function(event) {

    // Prevent default click functionality
    event.preventDefault();

    // Update active index
    this.index = this.ui.tabs.indexOf(event.target.parentNode);

    // Scroll the carousel
    this.scroll();

  };

  /**
   * Method to handle scrolling the carousel.
   *
   * @method Carousel.scroll
   */
  Carousel.prototype.scroll = function() {

    // Iterate over the pagination elements
    for (var index = 0; index < this.ui.tabs.length; index++) {
      // Get the current element in the loop
      var element = this.ui.tabs[index];
      var active = this.index === index;
      var link = dom(".link-text", this.ui.items[index]);
      // Set the selected state
      element.setAttribute("aria-selected", active ? "true" : "false");
      // Ensure links in active slide are tabbable
      if (link) {
        if (active) {
          link.removeAttribute("tabindex");
        } else {
          link.setAttribute("tabindex", "-1");
        }
      }
    }

    // Calculate the amount to scroll by
    var amount = -(100 / this.ui.tabs.length) * this.index;
    // Set the transform to move the wrapper
    this.ui.wrapper.style.transform = "translate3d(" + amount + "%, 0, 0)";

  };

  /**
   * Method to control the carousel with the keyboard input.
   *
   * @method Carousel.keydown
   */
  Carousel.prototype.keydown = function(event) {

    var key = event.which;
    // Get the active element
    var active = document.activeElement;
    // If going backwards, shift is true
    var shift = !!event.shiftKey;

    // Switch logic based on key pressed
    switch(key) {

      // Handle on press of the tab key
      case config.keys.TAB:

        if (this.ui.pagination.indexOf(active) > -1 && !shift) {
          var link = dom(".link-text", this.ui.items[this.index]);
          if (link) {
            // Prevent default tabbing functionality
            event.preventDefault();
            // Focus on the link in the content
            link.focus();
          }
        }

        if (this.ui.links.indexOf(active) > -1 && !shift) {
          // Prevent default tabbing functionality
          event.preventDefault();
          // Focus on the first button
          this.ui.buttons[0].focus();
        }

        // Temporarily disable link tabbing to keep flow
        if (this.ui.buttons.indexOf(active) > -1 && active.dataset.direction === "next") {
          var link = dom(".link-text", this.ui.items[this.index]);
          if (link) {
            link.setAttribute("tabindex", "-1");
            window.setTimeout(function() {
              link.removeAttribute("tabindex");
            }, 500);
          }
        }

        break;

      // Handle on press of the arrow keys
      case config.keys.UP:
      case config.keys.DOWN:
      case config.keys.RIGHT:
      case config.keys.LEFT:

        if (this.ui.pagination.indexOf(active) > -1) {
          // Prevent default tabbing functionality
          event.preventDefault();
          // Progress forward if using the right or down keys
          var next = key === config.keys.RIGHT || key === config.keys.DOWN;
          // Update active index
          this.index = this.getNextIndex(next);
          // Scroll the carousel
          this.scroll();
          // Focus the next pagination item
          this.ui.pagination[this.index].focus();
        }

        break;

    }

  };

  // Expose the public class
  return Carousel;

})();
